import Footermain from "./Footer_main";
import { Link } from "react-router-dom";
// images
import course1 from "./content/course1.png";
import course2 from "./content/course2.jpg";
import course3 from "./content/course3.jpg";
//css import
import "./css-components/home.css";
import "./css-components/courses.css";


function Courses(){

    return(
    
         <>
        <section className="courses">
              <div className="container courses__container">
                  <article className="course">
                      <div className="course__image">
                          <img src={course1} alt="" />
                      </div>
                      <div className="course__info">
                      <h4>Responsive Media Website UI Design</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est alias autem esse fugit omnis non eligendi? Dolorem, omnis!</p>
                      <Link to="./courses" className="btn btn-primary">Learn More</Link>
                      </div>
                  </article>

                  <article className="course">
                      <div className="course__image">
                          <img src={course2} alt="" />
                      </div>
                      <div className="course__info">
                      <h4>Responsive Smart Home Web Design</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est alias autem esse fugit omnis non eligendi? Dolorem, omnis!</p>
                      <Link to="./courses" className="btn btn-primary">Learn More</Link>
                      </div>
                  </article>

                  <article className="course">
                      <div className="course__image">
                          <img src={course3} alt="" />
                      </div>
                      <div className="course__info">
                      <h4>Responsive Admin Dashboard UI Design</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est alias autem esse fugit omnis non eligendi? Dolorem, omnis!</p>
                      <Link to="./courses" className="btn btn-primary">Learn More</Link>
                      </div>
                  </article>
                  <article className="course">
                      <div className="course__image">
                          <img src={course1} alt="" />
                      </div>
                      <div className="course__info">
                      <h4>Responsive Media Website UI Design</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est alias autem esse fugit omnis non eligendi? Dolorem, omnis!</p>
                      <Link to="./courses" className="btn btn-primary">Learn More</Link>
                      </div>
                  </article>

                  <article className="course">
                      <div className="course__image">
                          <img src={course2} alt="" />
                      </div>
                      <div className="course__info">
                      <h4>Responsive Smart Home Web Design</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est alias autem esse fugit omnis non eligendi? Dolorem, omnis!</p>
                      <Link to="./courses" className="btn btn-primary">Learn More</Link>
                      </div>
                  </article>

                  <article className="course">
                      <div className="course__image">
                          <img src={course3} alt="" />
                      </div>
                      <div className="course__info">
                      <h4>Responsive Admin Dashboard UI Design</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est alias autem esse fugit omnis non eligendi? Dolorem, omnis!</p>
                      <Link to="./courses" className="btn btn-primary">Learn More</Link>
                      </div>
                  </article>
                  <article className="course">
                      <div className="course__image">
                          <img src={course1} alt="" />
                      </div>
                      <div className="course__info">
                      <h4>Responsive Media Website UI Design</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est alias autem esse fugit omnis non eligendi? Dolorem, omnis!</p>
                      <Link to="./courses" className="btn btn-primary">Learn More</Link>
                      </div>
                  </article>

                  <article className="course">
                      <div className="course__image">
                          <img src={course2} alt="" />
                      </div>
                      <div className="course__info">
                      <h4>Responsive Smart Home Web Design</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est alias autem esse fugit omnis non eligendi? Dolorem, omnis!</p>
                      <Link to="./courses" className="btn btn-primary">Learn More</Link>
                      </div>
                  </article>

                  <article className="course">
                      <div className="course__image">
                          <img src={course3} alt="" />
                      </div>
                      <div className="course__info">
                      <h4>Responsive Admin Dashboard UI Design</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est alias autem esse fugit omnis non eligendi? Dolorem, omnis!</p>
                      <Link to="./courses" className="btn btn-primary">Learn More</Link>
                      </div>
                  </article>
              </div>
        </section>

         <Footermain/>
      </>
    )

}
export default Courses;